import {Header as HeaderUI} from '@travel-frontend/ui-components';
import {memo} from 'react';

import {useHeaderConfig} from '@/modules/common/hooks/useHeaderConfig';

const MemoizedHeaderUI = memo(HeaderUI);

export const Header = () => {
  const headerConfig = useHeaderConfig();

  return (
    <MemoizedHeaderUI
      path={import.meta.env.VITE_HOMEPAGE_URL}
      // @ts-expect-error ...
      config={headerConfig}
    />
  );
};
